module.exports = __webpack_public_path__ + "static/media/childs-diet.9730c2ba.pdf";